const legal = {
  smavaLegalHint:
    'smava versendet Informationen und Umfragen zu unserer Dienstleistung unter Verwendung elektronischer Post. Dem Erhalt kann ich jederzeit per E-Mail an info@smava.de widersprechen.',
  defaultLegalHint:
    'Wir versenden Informationen und Umfragen zu unserer Dienstleistung unter Verwendung elektronischer Post. Dem Erhalt kann ich jederzeit per E-Mail an kredite@finanzcheck.de widersprechen.'
}

export default legal
